import { render } from "./news-tests.vue?vue&type=template&id=b821a880&scoped=true"
import script from "./news-tests.vue?vue&type=script&lang=js"
export * from "./news-tests.vue?vue&type=script&lang=js"

import "./news-tests.vue?vue&type=style&index=0&id=b821a880&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b821a880"]])

export default __exports__